import questions from '../assets/questions.json';
import questionView from './views/questionView';

// Application state to manage questions, their categorization, and the current stream of questions
export const state = {
  allQuestions: [], // Array to hold all loaded questions
  randomizedQuestions: [], // Array to hold questions after randomization
  alreadySeenQuestions: [], // Array to track questions that have already been seen, NOT YET USED
  categorizedQuestions: {}, // Object to hold questions categorized by category and subcategory
  currentStreamOfQuestions: [], // Array to hold the current stream of questions being displayed
};

/**
 * Loads question data from the provided JSON file and organizes it.
 * This includes randomizing the questions and categorizing them by category and subcategory.
 */
export const loadQuestionData = function () {
  // 1) Load the question data from the JSON file
  state.allQuestions = questions;

  // 2) Randomize the questions and store them in a new array
  state.randomizedQuestions = state.allQuestions
    .slice() // Create a shallow copy of the array
    .sort(() => Math.random() - 0.5); // Shuffle the questions randomly

  // 3) Categorize the questions based on categories and subcategories in the randomizedQuestions array
  state.categorizedQuestions = state.randomizedQuestions.reduce(
    (acc, question) => {
      const { category, subcategory } = question;

      // If the category does not exist in the accumulator, initialize it
      if (!acc[category]) {
        acc[category] = {
          'Všechny otázky': [], // Initialize the "Všechny otázky" subcategory for each category
        };
      }

      // Add the question to the "Všechny otázky" subcategory (default for all questions in a category)
      acc[category]['Všechny otázky'].push(question);

      // Check if subcategory is not an empty string before adding it to the categorization
      if (subcategory && subcategory !== '') {
        if (!acc[category][subcategory]) {
          acc[category][subcategory] = []; // Initialize the specific subcategory if it does not exist
        }

        // Add the question to the specific subcategory
        acc[category][subcategory].push(question);
      }

      return acc;
    },
    {}
  );

  // Removed console.log statement for cleaner code
};

/**
 * Sets the current stream of questions to be displayed based on the selected category and subcategory.
 * @param {string} category - The category of questions to be displayed.
 * @param {string} subcategory - The subcategory of questions to be displayed.
 */
export const setCurrentStreamOfQuestions = function (category, subcategory) {
  state.currentStreamOfQuestions =
    state.categorizedQuestions[category][subcategory].slice(); // Set the stream to the selected subcategory
};

/**
 * Finds the index of the currently displayed question within the current stream of questions.
 * @returns {number} The index of the current question.
 */
export const getCurrentQuestionIndex = function () {
  // 0) Get the text of the currently displayed question
  const currentQuestionText = questionView._parentElement.innerHTML;

  // 1) Find the index of the current question within the current stream
  const currentQuestionIndex = state.currentStreamOfQuestions.findIndex(
    question => question.text === currentQuestionText
  );

  return currentQuestionIndex;
};

/**
 * Loads and renders the next question in the current stream of questions.
 */
export const loadNextQuestion = function () {
  // 1) Find the index of the current question within all questions
  const currentQuestionIndex = state.allQuestions.indexOf(
    state.currentQuestion
  );

  // 2) Set the current question to the next question in the array
  state.currentQuestion = state.allQuestions[currentQuestionIndex + 1];

  // 3) Render the next question in the view
  questionView.renderQuestion(state.currentQuestion.text);
};
